import React from 'react';
import CardsContent from "./cards-content.jsx";
import DetailsContent from "./details-content.jsx";
import BarChartContent from "./bar-chart-content.jsx";
import LineChartContent from "./line-chart-content.jsx";

const ReportContent = ({ data, collapsed, boName, hasPermission }) => {

    const unitCharts = Object.entries(data?.unit_graphics || {}).map(([unitName, values], index) => {
        const idUnit = unitName
            .normalize('NFD')
            .replace(/[\u0300-\u036f]/g, '')
            .replace(/[()]/g, '')
            .replace(/\s+/g, '-')
            .replace(/[^\w-]/g, '')
            .toLowerCase();

        return {
            id: `subtracted-by-unit-${collapsed}-${idUnit}-${index}`,
            title: unitName,
            data: Array.isArray(values) ? values : []
        };
    });

    const isDuoChart = (chart) => {
        return (chart?.data?.length || 0) <= 3;
    };

    const renderedUnitCharts = [];

    for (let index = 0; index < unitCharts.length; index++) {
        const currentChart = unitCharts[index];
        const nextChart = unitCharts[index + 1];

        if (isDuoChart(currentChart) && nextChart && isDuoChart(nextChart)) {
            renderedUnitCharts.push(
                <React.Fragment key={currentChart.id}>
                    <div className="row">
                        <BarChartContent
                            key={currentChart.id}
                            data={currentChart.data}
                            title={currentChart.title}
                            elementId={currentChart.id}
                            responsive={true}
                        />

                        <BarChartContent
                            key={nextChart.id}
                            data={nextChart.data}
                            title={nextChart.title}
                            elementId={nextChart.id}
                            responsive={true}
                        />
                    </div>

                    {index !== unitCharts.length - 2 && <div className="chart-divisor"/>}
                </React.Fragment>
            );

            index++;
        } else {
            renderedUnitCharts.push(
                <React.Fragment key={currentChart.id}>
                    <BarChartContent
                        data={currentChart.data}
                        title={currentChart.title}
                        elementId={currentChart.id}
                        divisor={index+1 !== unitCharts.length}
                    />
                </React.Fragment>
            );
        }
    }

    return (
        <>
            <div className="report-divisor print:break-after-avoid! mb-6">
                <span className="divisor-title">
                    VISÃO GERAL
                </span>
            </div>

            <CardsContent key={`cards-${collapsed}`} data={data?.stolen_item_cards} boName={boName}/>

            <BarChartContent key={`subtracted-by-type-${collapsed}`} data={data?.stolen_item_graphics?.stolen_items_type} title={'Itens subtraídos por tipo'} elementId={`subtracted-by-type-${collapsed}`}/>

            <BarChartContent key={`subtracted-by-subtype-${collapsed}`} data={data?.stolen_item_graphics?.stolen_items_subtype} title={'Itens subtraídos por subtipo'} elementId={`subtracted-by-subtype-${collapsed}`}/>

            <BarChartContent key={`subtracted-by-bo-${collapsed}`} data={data?.stolen_item_graphics?.stolen_items_bo} title={`Itens subtraídos por ${boName}`} elementId={`subtracted-by-bo-${collapsed}`}/>

            <BarChartContent key={`subtracted-by-reason-${collapsed}`} data={data?.stolen_item_graphics?.stolen_items_nature} title={'Itens subtraídos por natureza'} elementId={`subtracted-by-reason-${collapsed}`}/>

            <BarChartContent key={`subtracted-by-neighborhood-${collapsed}`} data={data?.stolen_item_graphics?.stolen_items_neighborhood} title={'Itens subtraídos por bairro'} elementId={`subtracted-by-neighborhood-${collapsed}`} divisor={false}/>


            <div className="report-divisor print:break-after-avoid! mb-6">
                <span className="divisor-title">
                    DETALHAMENTO
                </span>
            </div>

            <DetailsContent key={`details-${collapsed}`} data={data?.stolen_items_table} boName={boName} hasPermission={hasPermission}/>


            <div className="report-divisor print:break-after-avoid! mb-6">
                <span className="divisor-title">
                    ITENS SUBTRAÍDOS POR UNIDADES DE MEDIDA
                </span>
            </div>

            {renderedUnitCharts}


            <div className="report-divisor print:break-after-avoid! mb-6">
                <span className="divisor-title">
                    ANÁLISE TEMPORAL
                </span>
            </div>

            <LineChartContent key={`subtracted-by-day-${collapsed}`} data={data?.temporal_analysis?.day_analysis} title={'Itens subtraídos por dia'} elementId={`subtracted-by-day-${collapsed}`} elementName={'Dia'}/>

            <BarChartContent key={`subtracted-by-dow-${collapsed}`} data={data?.temporal_analysis?.weekday_analysis} title={'Itens subtraídos por dia da semana'} customTitle={'Subtraídos por dia da semana'} elementId={`subtracted-by-dow-${collapsed}`} elementName={'Dia da semana'}/>

            <LineChartContent key={`subtracted-by-month-${collapsed}`} data={data?.temporal_analysis?.month_analysis} title={'Itens subtraídos por mês'} elementId={`subtracted-by-month-${collapsed}`} elementName={'Mês'} divisor={false}/>


            <div id="chart-tables"/>
        </>
    );
};

export default ReportContent;